import React from "react";

export default function IconShortlist({ selected }) {
  return selected ? (
    <svg
      className="icon-shortlisted"
      width="20px"
      height="19px"
      viewBox="0 0 20 19"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Icons-Shortlist-Selected</title>
      <desc>Created with Sketch.</desc>
      <g transform="translate(-955.000000, -876.000000)" fill="#4B4E6A">
        <g
          id="Listings-Shortlist"
          transform="translate(955.000000, 856.000000)"
        >
          <g
            id="Icons-Shortlist-Selected"
            transform="translate(0.000000, 20.000000)"
          >
            <g>
              <path d="M19.498881,6.79098644 L13.5165866,5.60943272 L10.5325959,0.312676421 C10.4778121,0.21544748 10.3968702,0.134999169 10.2981606,0.0797218017 C10.0015383,-0.0875909438 9.62249351,0.0170412157 9.45419367,0.313169969 L6.48352873,5.60943272 L0.50320856,6.79098644 C0.385744155,6.8131961 0.280124899,6.86699282 0.195234657,6.94694759 C0.0748089639,7.05947651 0.00521870692,7.21198282 0.000283227705,7.37633428 C-0.00465225151,7.54019219 0.055067047,7.69615333 0.167595973,7.81559193 L4.31438561,12.2772651 L3.58788307,18.3123691 C3.57406373,18.506827 3.62786045,18.6647623 3.736441,18.7886429 C3.84551509,18.9120299 3.99654075,18.986062 4.16138576,18.9974136 L4.16533414,18.9974136 C4.26700501,19.0077782 4.37262427,18.9865556 4.46689192,18.9436169 L10.0000577,16.3909871 L15.5347041,18.944604 C15.6413104,18.9934653 15.7582813,19.011233 15.8727844,18.9984007 C16.0381229,18.9781653 16.1852002,18.8952492 16.2868711,18.7649526 C16.3880484,18.6361366 16.4324677,18.4752399 16.4127258,18.3133562 L15.6852362,12.2772651 L19.8305452,7.81756612 C19.9124741,7.73119523 19.9662709,7.62557598 19.9884805,7.51107286 C20.0200676,7.35066979 19.9860128,7.18779897 19.8947064,7.05157975 C19.8019194,6.91486697 19.6617518,6.82207996 19.498881,6.79098644 L19.498881,6.79098644 Z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      className="icon-shortlist"
      width="20px"
      height="19px"
      viewBox="0 0 20 19"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Icons-Shortlist</title>
      <desc>Created with Sketch.</desc>
      <g stroke="none" strokeWidth="1" fillRule="evenodd">
        <g transform="translate(0.000000, -20.000000)">
          <g>
            <g transform="translate(0.000000, 20.000000)">
              <path d="M14.5846243,11.6549012 C14.4607438,11.7871721 14.4020116,11.9633687 14.42126,12.1410459 L15.044611,17.3617958 L10.2542349,15.159585 C10.0888963,15.0830851 9.89888035,15.0830851 9.73304825,15.159585 L4.94316566,17.3617958 L5.56701024,12.1370975 C5.5882328,11.9604074 5.53196834,11.7837172 5.41252974,11.6519399 L1.82789118,7.78499196 L7.00372824,6.76828324 C7.1794313,6.73176069 7.33193761,6.61923177 7.41929559,6.45981579 L10.0000577,1.86932657 L12.578352,6.4558674 C12.6676842,6.61923177 12.820684,6.73176069 12.9993484,6.76877679 L18.1722242,7.78499196 L14.5846243,11.6549012 Z M19.498881,6.79098644 L13.5165866,5.60943272 L10.5325959,0.312676421 C10.4778121,0.21544748 10.3968702,0.134999169 10.2981606,0.0797218017 C10.0015383,-0.0875909438 9.62249351,0.0170412157 9.45419367,0.313169969 L6.48352873,5.60943272 L0.50320856,6.79098644 C0.385744155,6.8131961 0.280124899,6.86699282 0.195234657,6.94694759 C0.0748089639,7.05947651 0.00521870692,7.21198282 0.000283227705,7.37633428 C-0.00465225151,7.54019219 0.055067047,7.69615333 0.167595973,7.81559193 L4.31438561,12.2772651 L3.58788307,18.3123691 C3.57406373,18.506827 3.62786045,18.6647623 3.736441,18.7886429 C3.84551509,18.9120299 3.99654075,18.986062 4.16138576,18.9974136 L4.16533414,18.9974136 C4.26700501,19.0077782 4.37262427,18.9865556 4.46689192,18.9436169 L10.0000577,16.3909871 L15.5347041,18.944604 C15.6413104,18.9934653 15.7582813,19.011233 15.8727844,18.9984007 C16.0381229,18.9781653 16.1852002,18.8952492 16.2868711,18.7649526 C16.3880484,18.6361366 16.4324677,18.4752399 16.4127258,18.3133562 L15.6852362,12.2772651 L19.8305452,7.81756612 C19.9124741,7.73119523 19.9662709,7.62557598 19.9884805,7.51107286 C20.0200676,7.35066979 19.9860128,7.18779897 19.8947064,7.05157975 C19.8019194,6.91486697 19.6617518,6.82207996 19.498881,6.79098644 L19.498881,6.79098644 Z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
